import { Button } from "@mui/material";

export const CopyGridToJsonClipboard = ({ rows }) => {
  const handleCopyJSONToClipboard = () => {
    if (!rows.length) return;
    const jsonData = JSON.stringify(rows);

    navigator.clipboard
      .writeText(jsonData)
      .then(() => alert("Copied to clipboard"))
      .catch(() => alert("Failed to copy"));
  };
  return (
    <Button
      variant="contained"
      color="primary"
      sx={{ mt: 2 }}
      onClick={handleCopyJSONToClipboard}
    >
      Copy JSON To Clipboard
    </Button>
  );
};
